import { EventData, InsuranceDetailsState, InsuranceRequest } from '@/utils/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: InsuranceDetailsState = {
  insuranceEventsList: [],
  loading: false,
  error: null,
};

const insuranceDetailsSlice = createSlice({
  name: 'insuranceDetails',
  initialState,
  reducers: {
    fetchInsuranceDetailsRequest: (state, _action: PayloadAction<InsuranceRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchInsuranceDetailsSuccess: (state, action: PayloadAction<EventData[]>) => {
      state.insuranceEventsList = action.payload;
      state.loading = false;
    },
    fetchInsuranceDetailsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchInsuranceDetailsRequest,
  fetchInsuranceDetailsSuccess,
  fetchInsuranceDetailsFailure,
} = insuranceDetailsSlice.actions;

export default insuranceDetailsSlice.reducer;
